// @vue/component
import { useStrategyDetailsStore } from "@/stores/CrossWalkAnalysis/strategyDetails";
import { useCriticalGoalsStore } from "@/stores/WheelAnalysis/criticalGoals";
import { storeToRefs } from "pinia";
import { useCrosswalkChallengeStore } from "@/stores/CrossWalkAnalysis/challenge";
import { useGoalDetailsStore } from "@/stores/WheelAnalysis/goalDetails";

export default {
    name: "StrategyDetails",

    components: {},

    mixins: [],

    props: {},

    setup() {
        const strategyDetailsStore = useStrategyDetailsStore();
        const criticalGoalsStore = useCriticalGoalsStore();
        const challengeStore = useCrosswalkChallengeStore();
        const goalDetailsStore = useGoalDetailsStore();

        const { currentGoalId } = storeToRefs(strategyDetailsStore);
        const { currentStrategyId } = storeToRefs(strategyDetailsStore);
        const { currentDetailType } = storeToRefs(strategyDetailsStore);
        const { selectedStrategies } = storeToRefs(strategyDetailsStore);
        const { allStrategyDetails } = storeToRefs(strategyDetailsStore);
        const { selectedTargets } = storeToRefs(strategyDetailsStore);
        const { strategyNotes } = storeToRefs(strategyDetailsStore);
        const { selectedSubstrategies } = storeToRefs(strategyDetailsStore);
        const { matrixType } = storeToRefs(strategyDetailsStore);
        const { currentTargetId } = storeToRefs(strategyDetailsStore);

        const { allTargetDetails } = storeToRefs(goalDetailsStore);
        const { editMode } = storeToRefs(challengeStore);

        return {
            strategyDetailsStore,
            criticalGoalsStore,
            currentGoalId,
            currentDetailType,
            currentStrategyId,
            selectedStrategies,
            allStrategyDetails,
            selectedTargets,
            strategyNotes,
            allTargetDetails,
            selectedSubstrategies,
            matrixType,
            currentTargetId,
            editMode,
            goalDetailsStore
        };
    },

    data() {
        return {
            goalDescription: "",
            activeGoalItem: null,
            strategyDescription: "",
            strategyHeaderColors: ["#3460A8", "#3460A8", "#3460A8", "#3460A8", "#3460A8", "#3460A8", "#3460A8", "#4493F0"],
            targetAccordion: 1,
            strategyOptions: [
                "crosswalk.assessment.yes",
                "crosswalk.assessment.no",
                "crosswalk.assessment.developing",
                "crosswalk.assessment.forDiscussion",
            ],
        };
    },

    computed: {
        // currentGoalId is treated as 0-based everywhere for arrays.
        // goalNumber is the 1-based value used for display and i18n keys.
        goalNumber() {
            const idx = Number(this.currentGoalId);
            return Number.isFinite(idx) ? idx + 1 : 1;
        },
    },

    watch: {
        selectedStrategies: {
            deep: true,
            handler(newSelectedStrategies) {
                console.log(newSelectedStrategies);
                this.strategyDetailsStore.selectedStrategiesChanged();
            },
        },
        selectedSubstrategies: {
            deep: true,
            handler() {
                this.strategyDetailsStore.selectedSubstrategiesChanged();
            },
        },
        strategyNotes: {
            deep: true,
            handler() {
                this.strategyDetailsStore.strategyNotesChanged();
            },
        },
        selectedTargets: {
            deep: true,
            handler(newSelectedTargets) {
                console.log(newSelectedTargets);
                this.strategyDetailsStore.selectedTargetsChanged();
            },
        },
    },

    mounted() {
        this.strategyDetailsStore.fetchCrosswalkAnalysis();
    },

    methods: {
        goalIdFromTargetNumber(targetNumber) {
            // "7.2" -> "7", "7.a" -> "7"
            return String(targetNumber).split('.')[0]
        },
        headerStyles(index) {
            return {
                "background-color": this.strategyHeaderColors[index],
                color: "white",
                padding: "20px",
                "margin-bottom": "20px",
                "margin-top": "-35px",
            };
        },
    },
};
